import { Card, Col, Image, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import imgDefault from '../../../img/userdefault.png'

function TitleDoctorAgenda({t, doctor}){
    return (
        <Card className="shadow-1">
            <Card.Body>
                <Row className="align-items-center">
                    <Col xs="5" md="3" className="text-center">
                        <Image src={doctor?.url_photo ? doctor.url_photo : imgDefault} alt="avatar doctor" className="img-fluid doctor-foto doctor-foto-sm rounded-circle"/>
                    </Col>
                    <Col xs="7" md="9">
                        <h4>{`${doctor?.name} ${doctor?.lastName}`}</h4>
                        <span className="lead">{doctor?.espcialityList[0]?.name}</span>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )

}

export default withTranslation()(TitleDoctorAgenda)